<template>
  <div>
    <CrudList
      title="Spots"
      storeName="Spots"
      parentStoreName="Users_scroll"
      parentUrlKey="user_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
    >
      <template v-slot:type_spot_id="{ item }">
        {{ item.type_spot ? item.type_spot.name : "" }}
      </template>
      <template v-slot:spot="{ item }">
        {{ item.alias_id }}
        {{ item.address }}
        {{ item.unit ? item.unit : "" }}
        ({{
          item.user
            ? `${item.user.name || ""} ${item.user.last_name || ""}`
            : ""
        }})
      </template>
      <template v-slot:has_sticker="{ item }">
        {{ item.has_sticker ? 'SI' : "NO" }}
      </template>
      <template v-slot:availabledays="{ item }">
        <v-btn
          elevation="0"
          class="my-1 btn-black"
          color="primary"
          @click="
            $router.push(
              '/admin/users_scroll/' +
                $route.params.user_id +
                '/spots/' +
                item.id +
                '/available_days'
            )
          "
        >
          <img :src="icon_time" alt="" width="25px" />
        </v-btn>
      </template>
      <template v-slot:posters="{ item }">
        <v-row
          align="center"
          justify="center"
          v-if="item.posters && item.posters.length > 0"
        >
          <v-col
            cols="12"
            v-if="item.posters[0].photos && item.posters[0].photos.length > 0"
          >
            <v-list-item-avatar v-if="item.posters[0].photos[0].photo">
              <img :src="item.posters[0].photos[0].photo" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapState } from "vuex";

export default {
  components: { CrudList },
  data: () => ({
    offsetTop: 0,
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
  },
  computed: {
    ...mapState({
      icon_time: (state) => state.Menu.icon_time,
    }),
  },
};
</script>
